// // src/theme/themeEngine.js
// import React from 'react';
// import { themeMap } from './themeMap';

// export const transformClassName = (classString) => {
//   if (!classString || typeof classString !== 'string') return classString;
  
//   return classString
//     .split(/\s+/)
//     .map((cls) => themeMap[cls] || cls) // Ultra-safe: Map it, or leave it alone
//     .join(' ');
// };

// let isEngineInitialized = false;

// export const initThemeEngine = () => {
//   if (isEngineInitialized) return;
//   isEngineInitialized = true;

//   const originalCreateElement = React.createElement;
//   React.createElement = function () {
//     const args = Array.from(arguments);
//     const props = args[1];

//     if (props && props.className) {
//       props.className = transformClassName(props.className);
//     }
    
//     return originalCreateElement.apply(React, args);
//   };

//   try {
//     const jsxRuntime = require('react/jsx-runtime');
//     const patchJsx = (originalFn) => {
//       return function (type, props, key) {
//         if (props && props.className) {
//           props.className = transformClassName(props.className);
//         }
//         return originalFn(type, props, key);
//       };
//     };

//     if (jsxRuntime.jsx) jsxRuntime.jsx = patchJsx(jsxRuntime.jsx);
//     if (jsxRuntime.jsxs) jsxRuntime.jsxs = patchJsx(jsxRuntime.jsxs);
//   } catch (e) {
//     console.warn("ThemeEngine: JSX Runtime not found, using createElement fallback.");
//   }
// };
import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "light"
);
  useEffect(() => {
    document.documentElement.classList.remove("dark", "light");
    document.documentElement.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);